import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import {  Router , RouterModule  } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { User } from '@models/user';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-paperless',
  templateUrl: './paperless.component.html',
})
export class PaperlessComponent implements OnInit{
  checkEnrollment = false;
  firstTime: boolean;
  paperlessPage = '';
  user: User;
  isAcmic: boolean;
  isAutopayPage: boolean;

  constructor(public route: Router, private acmicService: AcmicService) {}

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.isAutopayPage = this.route.url.includes('e-pay') && this.route.url.includes('enroll');
  }

  checkPaperlessPage(): void {
    let page = '';
    const url = '/billing/paperless/',
      enrollCopy = '- Enroll in ';

    if (this.route.isActive(`${url}e-policy`, true)) {
      page = `${enrollCopy}e-policy`;
    } else if (this.route.isActive(`${url}e-pay`, true)) {
      page = `${enrollCopy}e-pay`;
    } else if (
      !this.route.isActive(`${url}e-pay`, true) &&
      !this.route.isActive(`${url}e-policy`, true) &&
      !this.route.isActive(`${url}e-bill`, true) &&
      !this.route.isActive('/billing/paperless', true)
    ) {
      this.checkEnrollment = true;
    } else if (this.route.isActive(`${url}e-bill`, true)) {
      page = `${enrollCopy}e-bill`;
    }
    this.paperlessPage = page;
  }
}
